import { useState } from "react";
import {
  copyWorkflowScheme,
  searchProjects,
  WorkflowSchemeViewModel,
} from "../api/jiraWorkflowsClient";
import { useSnackbar } from "notistack";
import { AxiosError } from "axios";

export const useJiraWorkflows = () => {
  const [selectedProjectId, setSelectedProjectId] = useState<string>("");
  const [isCopying, setIsCopying] = useState(false);
  const [copiedWorkflowScheme, setCopiedWorkflowScheme] =
    useState<WorkflowSchemeViewModel | null>(null);
  const { enqueueSnackbar } = useSnackbar();

  const loadProjects = async (filter: string) => {
    try {
      return await searchProjects(filter);
    } catch (error) {
      enqueueSnackbar("Failed to load projects with Jira Cloud", {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    }
    return [];
  };

  const handleCopyWorkflowScheme = async () => {
    if (!selectedProjectId) {
      enqueueSnackbar("Please select a project", {
        variant: "warning",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
      return;
    }

    setIsCopying(true);
    try {
      const projectCopied = await copyWorkflowScheme(selectedProjectId);
      setCopiedWorkflowScheme(projectCopied);
      enqueueSnackbar("Workflow scheme copied successfully", {
        variant: "success",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } catch (error) {
      let errorMsg = "";
      if (error instanceof AxiosError) {
        errorMsg = error?.response?.data.detail;
      } else {
        errorMsg = "Failed to copy workflow scheme";
      }
      enqueueSnackbar(errorMsg, {
        variant: "error",
        anchorOrigin: { vertical: "top", horizontal: "center" },
      });
    } finally {
      setIsCopying(false);
    }
  };

  return {
    loadProjects,
    selectedProjectId,
    setSelectedProjectId,
    isCopying,
    handleCopyWorkflowScheme,
    copiedWorkflowScheme,
  };
};
